import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DevFlagSelectors } from '@recruitee/dev-flags-data';

@Injectable({ providedIn: 'root' })
export class DevFlagsGuard {
  constructor(
    private router: Router,
    private store: Store,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const { devFlag } = route.data;

    if (!devFlag) throw new Error(`${devFlag} does not match DevFlags enum`);

    return this.store
      .select(DevFlagSelectors.isEnabled(devFlag))
      .pipe(map(enabled => enabled || this.router.createUrlTree(['/dashboard'])));
  }
}
